import React from "react";
import { Box, useTheme, useMediaQuery, Skeleton } from "@mui/material";
import TriangleBG from "../../../assets/Images/trianglebg.svg";

interface Props {
  title: string;
  price: string;
  icon: React.ReactElement;
  loading?: boolean;
}

const InvoiceCards = ({ title, price, icon, loading = false }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        position: "relative",
        zIndex: 0,
        backgroundColor: "white",
        borderRadius: "12px",
        flex: 1,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        px: 2,
        pt: 2,
        pb: 5,
        height: "150px",
        width: isMobile ? "auto" : "350px",
      }}
    >
      <img
        src={TriangleBG}
        alt="bg-img"
        style={{
          position: "absolute",
          zIndex: 1,
          top: 0,
          left: 0,
          width: "98px",
          height: "auto",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 10,
        }}
      >
        {icon}
      </div>
      <div
        style={{
          display: "grid",
          gap: isMobile ? 8 : 10,
          flex: 1,
        }}
      >
        <p
          style={{
            color: "#6C6F71",
            fontSize: isMobile ? "14px" : "18px",
            fontWeight: 400,
            margin: 0,
          }}
        >
          {title}
        </p>
        {loading ? (
          <Skeleton
            variant="rectangular"
            width={isMobile ? 80 : 120}
            height={isMobile ? 28 : 30}
            animation="wave"
            sx={{ borderRadius: 1 }}
          />
        ) : (
          <p
            style={{
              color: "#01060B",
              fontSize: isMobile ? "20px" : "28px",
              fontWeight: 700,
              margin: 0,
            }}
          >
            ${price || 0}
          </p>
        )}
      </div>
    </Box>
  );
};

export default InvoiceCards;
